AgrimarketControllers.controller('categoryOfferController', function () {});